const getScrollDistance = ({
  value,
  isRightToLeft,
  carouselRefCurrent,
}: {
  value: { offsetLeft: number; offsetWidth: number };
  isRightToLeft: boolean;
  carouselRefCurrent: HTMLDivElement;
}) => {
  const distance = isRightToLeft
    ? carouselRefCurrent.offsetWidth - value.offsetLeft - value.offsetWidth
    : value.offsetLeft;

  return distance;
};

export default getScrollDistance;
